/* eslint-disable import/no-anonymous-default-export */
import { Button } from "antd";
import { useContext } from "react";
import styled from "styled-components";
import { LogoutOutlined } from "@ant-design/icons";
import UsuariosContext from "../contexts/UsuariosContext";
import { UserOutlined } from '@ant-design/icons';

const TextUserLogged = styled.h2`
  margin-bottom: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  color: #1d94e4;
`;

const UsernameContainer = styled.div`
display: flex;
gap: 0.5rem;
justify-content: center;
align-items: center;
`;

const Container = styled.div<PerfilAuthProps>`
background: white;
display: flex;
justify-content: ${p => p.mode == 'inline' ? 'left' : 'center'};
padding: 1rem;

& > div
{
  justify-content: center;
  display: flex;
  flex-flow: ${p => p.mode == 'inline' ? 'row' : 'column'};
  gap:${p => p.mode == 'inline' ? '1rem' : '0.5rem'};
}

`;

const StyledUserOutlined = styled(UserOutlined)`
& > svg
{
  fill:white;
}
font-size:1.3rem;
background:#9e9e9e;
display: inherit;
margin: auto;
border-radius:50%;
padding:0.5rem;
`;

export interface PerfilAuthProps {
  mode?: ('inline' | 'column')
};

export default (props: PerfilAuthProps) => {
  const { user, signOut } = useContext(UsuariosContext);

  return (
    <>
      <Container mode={props.mode}>
        <div>
          <StyledUserOutlined />
          <UsernameContainer>
            <TextUserLogged>{user?.nombreUsuario}</TextUserLogged>
          </UsernameContainer>
          <Button
            style={{ color: '#d43c16', margin: 'auto' }}
            icon={<LogoutOutlined />}
            size="small"
            type="link"
            onClick={signOut}
          />
        </div>
      </Container>
    </>
  );
};
